import React from "react";
import type { MindMapNode as NodeType } from "./types";

interface MindMapNodeProps {
  node: NodeType;
  isRoot?: boolean;
  isExpanded?: boolean;
  onToggle: (id: string) => void;
  depth?: number;
}

const depthStyles: Record<number, React.CSSProperties> = {
  0: {
    background: "rgb(103, 58, 183)",
    color: "#fff",
    boxShadow: "0 4px 14px -3px rgba(103, 58, 183, 0.35)",
  },
  1: {
    background: "rgba(33, 150, 243, 0.95)",
    color: "#fff",
    boxShadow: "0 4px 14px -3px rgba(33, 150, 243, 0.35)",
  },
  2: {
    background: "rgba(0, 150, 136, 0.95)",
    color: "#fff",
    boxShadow: "0 4px 14px -3px rgba(0, 150, 136, 0.35)",
  },
};

export const MindMapNodeComponent: React.FC<MindMapNodeProps> = ({
  node,
  isRoot = false,
  isExpanded = false,
  onToggle,
  depth = 0,
}) => {
  const hasChildren = !!node.children?.length;
  const style = depthStyles[Math.min(depth, 2)];

  return (
    <button
      data-node-id={node.id}
      onClick={() => hasChildren && onToggle(node.id)}
      className={`relative inline-flex h-[38px] min-w-[150px] items-center justify-center whitespace-nowrap rounded-full text-sm font-medium shadow-md transition-all duration-200 ${
        hasChildren ? "cursor-pointer pr-9 hover:-translate-y-0.5 hover:shadow-lg" : "cursor-default px-4"
      } ${isRoot ? "h-[42px] min-w-[170px] font-semibold" : ""}`}
      style={style}
    >
      <span className={`font-sans ${hasChildren ? "pl-4" : ""}`}>{node.label}</span>
      {hasChildren && (
        <span
          className="absolute right-3.5 top-1/2 block h-2 w-2 -translate-y-1/2 border-b-2 border-r-2 border-white/80 transition-transform duration-200"
          style={{
            transform: `translateY(-50%) rotate(${isExpanded ? "135deg" : "-45deg"})`,
          }}
        />
      )}
    </button>
  );
};
